import { render, staticRenderFns } from "./AmbulanciasListado.vue?vue&type=template&id=260239b2"
import script from "./AmbulanciasListado.vue?vue&type=script&lang=js"
export * from "./AmbulanciasListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports